import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontMainNav from "../../shared/FrontMainNav/FrontMainNav";

const QUI_SOMMES_NOUS_IMAGE = "/All-In-Tech-Qui_somme_nous.png";

function WhoWeAre() {
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content who-we-are-page pb-5">
        <FrontMainNav />
        {/* Titre principal centré */}
        <h1 className="qui-sommes-nous-main-title">Qui sommes-nous ?</h1>

        {/* Section À propos : image (petite) à gauche, texte à droite sur toute la hauteur de l'image */}
        <section className="qui-sommes-nous-about">
          <div className="container">
            <div className="row align-items-flex-start qui-sommes-nous-top-row">
              <div className="col-lg-5 col-md-6">
                <div className="qui-sommes-nous-image-wrapper">
                  <img
                    src={QUI_SOMMES_NOUS_IMAGE}
                    alt="All-In-Tech - Solutions technologiques"
                    className="qui-sommes-nous-image"
                  />
                </div>
              </div>
              <div className="col-lg-7 col-md-6 qui-sommes-nous-text-col">
                <h2 className="qui-sommes-nous-company-title">ALL-IN-TECH</h2>
                <div className="qui-sommes-nous-content">
                  <p>
                    All-In-Tech est une entreprise sénégalaise spécialisée dans
                    la fourniture de solutions technologiques de pointe.
                    Initialement reconnus pour nos services informatiques, nous
                    élargissons aujourd'hui notre catalogue pour devenir votre
                    partenaire de confiance en matériel informatique et
                    électronique. Notre mission est de rendre la haute
                    technologie accessible aux professionnels et aux
                    particuliers au Sénégal.
                  </p>
                </div>
              </div>
            </div>
            {/* Nos valeurs : trois cartes avec barre violette à gauche (maquette) */}
            <div className="qui-sommes-nous-values-row">
              <h3 className="qui-sommes-nous-values-title">Nos valeurs</h3>
              <div className="nos-valeurs-cards">
                <div className="nos-valeurs-card">
                  <div className="nos-valeurs-card-inner">
                    <div className="nos-valeurs-card-bar" aria-hidden="true" />
                    <div className="nos-valeurs-card-content">
                      <h4 className="nos-valeurs-card-title">Innovation</h4>
                      <p className="nos-valeurs-card-desc">
                        Toujours proposer les dernières nouveautés technologiques.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="nos-valeurs-card">
                  <div className="nos-valeurs-card-inner">
                    <div className="nos-valeurs-card-bar" aria-hidden="true" />
                    <div className="nos-valeurs-card-content">
                      <h4 className="nos-valeurs-card-title">Fiabilité</h4>
                      <p className="nos-valeurs-card-desc">
                        Des produits authentiques et garantis provenant de fournisseurs sélectionnés.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="nos-valeurs-card">
                  <div className="nos-valeurs-card-inner">
                    <div className="nos-valeurs-card-bar" aria-hidden="true" />
                    <div className="nos-valeurs-card-content">
                      <h4 className="nos-valeurs-card-title">Proximité</h4>
                      <p className="nos-valeurs-card-desc">
                        Un service client réactif et à l'écoute des besoins spécifiques du marché local.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section Notre équipe */}
        <section className="notre-equipe-section">
          <div className="container">
            <div className="notre-equipe-header">
              <div className="notre-equipe-header-line" />
              <p className="notre-equipe-subtitle">QUI SOMMES-NOUS</p>
              <h2 className="notre-equipe-title">Notre équipe</h2>
            </div>
            <div className="row notre-equipe-cards">
              <div className="col-md-6">
                <div className="notre-equipe-card">
                  <p className="notre-equipe-card-description">
                    Passionné par l'entrepreneuriat et les solutions digitales,
                    il pilote la vision stratégique et le développement des
                    partenariats. Son objectif est d'offrir des produits fiables
                    et accessibles, adaptés aux besoins des particuliers comme
                    des professionnels.
                  </p>
                  <p className="notre-equipe-card-name">Mouhamadou Gueye</p>
                  <p className="notre-equipe-card-role">CEO</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="notre-equipe-card">
                  <p className="notre-equipe-card-description">
                    Spécialisée en stratégie digitale et relation client, elle
                    veille à l'image de la marque, à l'expérience utilisateur et
                    au développement commercial. Son ambition est d'allier
                    qualité, confiance et satisfaction client.
                  </p>
                  <p className="notre-equipe-card-name">Fatou Kassé</p>
                  <p className="notre-equipe-card-role">
                    Cheffe des opérations
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section Mot du fondateur (maquette : ligne violette au-dessus du titre, fond lavande) */}
        <section className="mot-fondateur-section">
          <div className="container mot-fondateur-container">
            <div className="mot-fondateur-header">
              <div className="mot-fondateur-accent-line" aria-hidden="true" />
              <h2 className="mot-fondateur-title">Mot du fondateur</h2>
            </div>
            <p className="mot-fondateur-text">
              Chez All In Tech, nous croyons que la technologie est le moteur du
              développement. En lançant cette plateforme e-commerce, nous voulons
              offrir à chaque Sénégalais la possibilité de s'équiper avec du
              matériel de qualité, sans compromis sur le service après-vente.
            </p>
            <p className="mot-fondateur-name">Mouhamadou Gueye</p>
            <p className="mot-fondateur-role">Fondateur</p>
          </div>
        </section>
      </div>
      <FrontFooter />
    </div>
  );
}

export default WhoWeAre;
